<!-- @format -->

<template>
    <div>
        <export-form @export="loadTable($event)" :users="this.users" :csv="csv" />
        <BaseTable v-if="items.length > 0" hover :items="items" :header="exportHeader"> </BaseTable>
    </div>
</template>

<script>
import AZ from "@/utils/AzApi";
import ExportForm from "../components/ExportForm.vue";
import BaseTable from "../components/BaseTable.vue";

export default {
    components: { ExportForm, BaseTable },
    name: "Export",
    data() {
        return {
            users: [],
            userById: {},
            items: [],
            item: {
                levelThree: "",
                levelTwo: "",
                levelOne: "",
                title: "",
                startTime: "",
                endTime: "",
                durationInMinutes: "",
                durationRoundedToQuarterHours: "",
                description: "",
                user: ""
            },
            exportHeader: [
                {
                    key: "levelThree",
                    label: this.$t("export.levelThree"),
                    sortable: true
                },
                {
                    key: "levelTwo",
                    label: this.$t("export.levelTwo"),
                    sortable: true
                },
                {
                    key: "title",
                    label: this.$t("export.title"),
                    sortable: true
                },
                {
                    key: "user",
                    label: this.$t("export.user"),
                    sortable: true
                },
                {
                    key: "durationInMinutes",
                    label: this.$t("export.durationInMinutes"),
                    sortable: false
                },
                {
                    key: "durationRoundedToQuarterHours",
                    label: this.$t("export.durationRoundedToQuarterHours"),
                    sortable: false
                },
                {
                    key: "startTime",
                    label: this.$t("export.startTime"),
                    sortable: true
                },
                {
                    key: "endTime",
                    label: this.$t("export.endTime"),
                    sortable: true
                },
                {
                    key: "description",
                    label: this.$t("export.description"),
                    sortable: false
                }
            ],
            csv: ""
        };
    },

    methods: {
        loadTable: function (data) {
            const projects = this.groupActivities(data);
            const rows = [];
            for (const projectName of Object.keys(projects).sort()) {
                const project = projects[projectName];

                rows.push({
                    levelThree: projectName,
                    levelTwo: "",
                    levelOne: "",
                    title: "",
                    user: "Total",
                    durationInMinutes: project.duration,
                    durationRoundedToQuarterHours: project.roundedDuration,
                    startTime: "",
                    endTime: "",
                    description: ""
                });

                for (const userId of Object.keys(project.durationPerUser).sort()) {
                    const data = project.durationPerUser[userId];
                    rows.push({
                        levelThree: projectName,
                        levelTwo: "",
                        levelOne: "",
                        title: "",
                        user: this.usernameById(userId),
                        durationInMinutes: data.duration,
                        durationRoundedToQuarterHours: data.roundedDuration,
                        startTime: "",
                        endTime: "",
                        description: ""
                    });
                }
                for (const ticketId of Object.keys(project.tickets).sort()) {
                    const ticket = project.tickets[ticketId];
                    rows.push({
                        levelThree: projectName,
                        levelTwo: ticketId,
                        levelOne: "",
                        title: ticket.title,
                        user: "Total",
                        durationInMinutes: ticket.duration,
                        durationRoundedToQuarterHours: ticket.roundedDuration,
                        startTime: "",
                        endTime: "",
                        description: ""
                    });
                    for (const userId of Object.keys(ticket.users).sort()) {
                        const times = ticket.users[userId].times;
                        for (const day of Object.keys(times).sort()) {
                            for (const activity of times[day].activities.sort(a => a.startTime)) {
                                rows.push({
                                    levelThree: projectName,
                                    levelTwo: ticketId,
                                    levelOne: "",
                                    title: ticket.title,
                                    user: this.usernameById(userId),
                                    durationInMinutes: activity.durationInMinutes,
                                    durationRoundedToQuarterHours: "",
                                    startTime: activity.startTime,
                                    endTime: activity.endTime,
                                    description: activity.description
                                });
                            }
                        }
                    }
                }
            }

            this.items = rows;
            const headers = [
                "project",
                "ticketid",
                "title",
                "employee",
                "duration",
                "duration rounded",
                "start time",
                "end time",
                "description"
            ];
            this.csv =
                "data:text/csv;charset=utf-8," +
                headers.map(col => '"' + (col || "").replace(/"/g, '""') + '"').join(",") +
                "\n" +
                this.items
                    .map(obj => {
                        const duration = Math.floor(obj.durationInMinutes / 60) + ":" + (obj.durationInMinutes % 60);
                        const roundedDuration =
                            Math.floor(obj.durationRoundedToQuarterHours / 60) +
                            ":" +
                            (obj.durationRoundedToQuarterHours % 60);
                        const row = [
                            obj.levelThree,
                            obj.levelTwo,
                            obj.title,
                            obj.user,
                            duration == "0:0" ? "" : duration,
                            roundedDuration == "0:0" ? "" : roundedDuration,
                            obj.startTime,
                            obj.endTime,
                            obj.description
                        ];

                        return row.map(col => '"' + (col || "").replace(/"/g, '""') + '"').join(",");
                    })
                    .join("\n") +
                "\n";
        },
        usernameById(id) {
            return this.userById[id] || "unknown user: " + id;
        },
        retrieveUsers() {
            AZ.retrieveAllUsers().then(response => {
                response.data.forEach(user => {
                    console.log(user.id, user.id.split("-").join(""));
                    this.userById[user.id.split("-").join("").toUpperCase()] = user.username;
                    this.users.push({
                        text: user.username,
                        value: user.id,
                        disabled: false
                    });
                });
            });
        },
        groupActivities(activities) {
            const projects = {};

            for (const activity of activities) {
                if (!projects[activity.level2]) {
                    projects[activity.level2] = {
                        project: activity.level2,
                        duration: 0,
                        roundedDuration: 0,
                        tickets: {}
                    };
                }

                const project = projects[activity.level2];

                if (!project.tickets[activity.level1]) {
                    project.tickets[activity.level1] = {
                        ticketId: activity.level1,
                        title: activity.title.substring(activity.title.indexOf("]") + 1),
                        duration: 0,
                        roundedDuration: 0,
                        users: {}
                    };
                }

                const ticket = project.tickets[activity.level1];

                if (!ticket.users[activity.userId]) {
                    ticket.users[activity.userId] = {
                        userId: activity.userId,
                        duration: 0,
                        roundedDuration: 0,
                        times: {}
                    };
                }

                const times = ticket.users[activity.userId].times;
                const day = activity.startTime.substring[(0, 10)];
                if (!times[day]) {
                    times[day] = {
                        duration: 0,
                        activities: []
                    };
                }
                times[day].activities.push(activity);
                times[day].duration += activity.durationInMinutes;
            }

            for (const projectName in projects) {
                const project = projects[projectName];
                project.durationPerUser = {};

                for (const ticketId in project.tickets) {
                    const ticket = project.tickets[ticketId];

                    for (const userId in ticket.users) {
                        const times = ticket.users[userId].times;

                        for (const day in times) {
                            const dayData = times[day];
                            dayData.roundedDuration =
                                Math.floor(dayData.duration / 15) * 15 + (dayData.duration % 15 == 0 ? 0 : 15);
                            ticket.users[userId].duration += dayData.duration;
                            ticket.users[userId].roundedDuration += dayData.roundedDuration;
                        }

                        ticket.duration += ticket.users[userId].duration;
                        ticket.roundedDuration += ticket.users[userId].roundedDuration;

                        if (!project.durationPerUser[userId]) {
                            project.durationPerUser[userId] = {
                                duration: ticket.users[userId].duration,
                                roundedDuration: ticket.users[userId].roundedDuration
                            };
                        } else {
                            project.durationPerUser[userId].duration += ticket.users[userId].duration;
                            project.durationPerUser[userId].roundedDuration += ticket.users[userId].roundedDuration;
                        }
                    }

                    project.duration += ticket.duration;
                    project.roundedDuration += ticket.roundedDuration;
                }
            }

            return projects;
        },
        flattenObject: function (obj, prefix = "", depth = 0) {
            const result = [];
            for (const key in obj) {
                const value = obj[key];
                const newPrefix = prefix ? `${prefix}.${key}` : key;

                if (typeof value === "object" && value !== null && depth < 5) {
                    result.push(...this.flattenObject(value, newPrefix, depth + 1));
                } else {
                    console.log(this.users[0].value.replace(/-/g, "").toUpperCase());
                    let newItem = { ...this.item };
                    let prefixList = prefix.split(".");
                    newItem.levelOne = prefixList[0] != "noLevelThree" ? prefixList[0] : "";
                    newItem.levelTwo = prefixList[2] != "noLevelTwo" ? prefixList[2] : "";
                    newItem.levelThree = prefixList[4] != "noLevelOne" ? prefixList[4] : "";
                    newItem.title = value.title.split("]")[1];
                    newItem.startTime = new Date(value.startTime).toLocaleString();
                    newItem.endTime = new Date(value.endTime).toLocaleString();
                    newItem.durationInMinutes = value.durationInMinutes;
                    newItem.durationRoundedToQuarterHours = value.durationRoundedToQuarterHours;
                    newItem.description = value.description;
                    newItem.user = this.users.find(
                        obj => obj.value.replace(/-/g, "").toUpperCase() === value.userId
                    )?.text;
                    result.push(newItem);
                }
            }
            return result;
        }
    },
    mounted() {
        this.retrieveUsers();
    }
};
</script>

<style></style>
